import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { AuthorizationDTO, HolderDTO, RequestFormDTO, PrintContractDTO } from '@app/requests/model/requests-model';
import { TpvBuyPrintRequestDTO } from '@app/revolving/model/revolving-model';
import { TranslateService } from '@ngx-translate/core';
import { PrintApi } from './print-api.service';
import * as FileSaver from 'file-saver';
import { DOWNLOAD, VIEW } from '@app/@core/constants/training.constants';

@Injectable()
export class PrintStore {
  constructor(private printApi: PrintApi, private translate: TranslateService, private dialog: MatDialog) {}

  public openPDFBinaryOnSuccess(data: any, numOperation: string, name: string) {
    // We should convert base64 file to blob
    var arrBuffer = this.base64ToArrayBuffer(data);

    let file = new Blob([arrBuffer], { type: 'application/pdf' });
    FileSaver.saveAs(file, name);
  }

  public openPDFOnSuccess(
    data: any,
    numOperation: string,
    language: string,
    name?: string,
    print?: PrintContractDTO,
    nif?: string,
    authorization?: boolean
  ) {
    console.log(data);
    let file = new Blob([data], { type: 'application/pdf' });
    let date = new Date();
    let namefile = '';
    if (print !== undefined && print.printSecure === 'S') {
      namefile = print.filename;
    } else if (authorization) {
      if (language == 'CA') {
        namefile =
          'Autorització_' +
          date.getDate().toString().padStart(2, '0') +
          (date.getMonth() + 1).toString().padStart(2, '0') +
          date.getFullYear();
      } else {
        namefile =
          'Autorización' +
          date.getDate().toString().padStart(2, '0') +
          (date.getMonth() + 1).toString().padStart(2, '0') +
          date.getFullYear();
      }
    } else {
      namefile =
        (name === '' || name === 'INE'
          ? language == 'CA'
            ? 'Contracte' + name + '_'
            : 'Contrato' + name + '_'
          : name) +
        (name === '' || name === 'INE' ? numOperation + '_' : '') +
        (print && print?.codeProduct && (name === '' || name === 'INE')
          ? print.codeProduct?.toString()?.substring(0, 2) + '_'
          : '') +
        (name === '' || name === 'INE'
          ? date.getDate().toString().padStart(2, '0') +
            (date.getMonth() + 1).toString().padStart(2, '0') +
            date.getFullYear() +
            '_'
          : '') +
        (name === '' || name === 'INE'
          ? this.addZero(date.getHours()) + this.addZero(date.getMinutes()) + this.addZero(date.getSeconds())
          : '') +
        (nif ? '_' + nif : '') +
        '.pdf';
    }
    FileSaver.saveAs(file, namefile);
  }

  private addZero(i: any) {
    if (i < 10) {
      i = '0' + i;
    }
    return i;
  }

  private base64ToArrayBuffer(data: any) {
    let binaryString = atob(data);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  public printRequest(request: RequestFormDTO, type: string): Promise<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '450px';
    console.log('Method: printRequest', request);
    return new Promise<any>((resolve, reject) => {
      this.printApi
        .postPrintRequest(request, type)
        .toPromise()
        .then(
          (data: any) => {
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public printContract(printContract: PrintContractDTO): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.printApi
        .postPrintContract(printContract)
        .toPromise()
        .then(
          (data: any) => {
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  convertAuthorizationToHolderDTO(request: RequestFormDTO | any, modeView: boolean): AuthorizationDTO {
    let downloadAuthorization: AuthorizationDTO;
    let operative: string;

    if (modeView) {
      if (request.codeOperative === 'BPU' || request.codeOperative === 'MNG') {
        operative = request.codeOperative;
      } else {
        operative = null;
      }
    } else {
      if (request.operative?.code === 'BPU' || request.operative?.code === 'MNG') {
        operative = request.operative.code;
      } else {
        operative = null;
      }
    }

    downloadAuthorization = {
      brand: request.brand,
      city: request.town,
      date: request.dateRequest,
      establishment: request.establishment,
      holderDTO: this.convertToHolderDTO(request),
      language: request.language,
      operative: operative,
      participants: request.participants ? request.participants : [],
    };

    return downloadAuthorization;
  }

  private convertToHolderDTO(request: RequestFormDTO | any): HolderDTO {
    let holderDTO: HolderDTO;

    holderDTO = {
      accountHolding: request.accountHolding,
      addressNumber: request.addressNumber,
      amountCard: request.amountCard,
      annualIngr: request.annualIngr,
      antiquityProperty: request.antiquityProperty,
      birthDate: request.birthDate,
      civilStatus: request.civilStatus,
      cnae: request.cnae,
      // codEan13: request.codEan13,
      comDom: request.comDom,
      companyCif: request.companyCif,
      companyName: request.companyName,
      companyPopulation: request.companyPopulation,
      companySector: request.companySector,
      countryBirth: request.countryBirth,
      dcBank: request.dcBank,
      documentId: request.documentId,
      door: request.door,
      email: request.email,
      entityBank: request.entityBank,
      expirationDate: request.expirationDate,
      floor: request.floor,
      houseTel: request.houseTel,
      housingExpenses: request.housingExpenses,
      iban: request.iban,
      incomeNetos: request.incomeNetos,
      incorpMonth: request.incorpMonth,
      incorpYear: request.incorpYear,
      indAuthorization: request.indAuthorization,
      ingrMonthVble: request.ingrMonthVble,
      insurance: request.insurance,
      mobileTel: request.mobileTel,
      modPaymentCard: request.modPaymentCard,
      name: request.name,
      nameAddress: request.nameAddress,
      nationality: request.nationality,
      numberBank: request.numberBank,
      observations: request.observations,
      occupation: request.occupation,
      officeBank: request.officeBank,
      peopleInCharge: request.peopleInCharge,
      postcode: request.postcode,
      regime: request.regime,
      secondSurname: request.secondSurname,
      sex: request.sex,
      sitVivienda: request.sitVivienda,
      subSit: request.subSit,
      surname: request.surname,
      telCompany: request.telCompany,
      town: request.town,
      workSituation: request.workSituation,
    };

    return holderDTO;
  }

  downloadAuthorization(authDTO: AuthorizationDTO, type: string) {
    return new Promise<any>((resolve, reject) => {
      this.printApi.postPrintAuthorization(authDTO).subscribe(
        (data: any) => {
          if (data) {
            let file = new Blob([data], { type: 'application/pdf' });
            if (type === VIEW) {
              let fileURL = URL.createObjectURL(file);
              window.open(fileURL);
            } else if (type === DOWNLOAD) {
              let date = new Date();
              let name =
                'Autorizacion_' +
                date.getDate().toString().padStart(2, '0') +
                (date.getMonth() + 1).toString().padStart(2, '0') +
                date.getFullYear();
              this.downloadPDF(file, name);
            }
            resolve(data);
          } else reject(data);
        },
        (error) => {
          console.error(error);
          const dialogConfig = new MatDialogConfig();
          dialogConfig.width = '90%';
          dialogConfig.maxWidth = '450px';

          dialogConfig.data = { text: error.error.error, icon: 'icon-ic_circle_cross' };
          this.dialog.open(ResponseDialogComponent, dialogConfig);
          reject(error);
        }
      );
    });
  }

  downloadTpvPurchasePrint(request: TpvBuyPrintRequestDTO) {
    this.printApi.postTpvPrint(request).subscribe(
      (data: any) => {
        if (data) {
          let file = new Blob([data], { type: 'application/pdf' });
          let fileName =
            'Boleta_' +
            (request.strNumContrato ? request.strNumContrato + '_' : '') +
            (request.strFecha ? request.strFecha + '_' : '') +
            (request.strHora ? request.strHora : '') +
            '.pdf';

          FileSaver.saveAs(file, fileName);
        }
      },
      (error) => console.error(error)
    );
  }

  public dowloadTPVRefundPrint(request: TpvBuyPrintRequestDTO) {
    this.printApi.postTpvRefundPrint(request).subscribe(
      (data: any) => {
        if (data) {
          let file = new Blob([data], { type: 'application/pdf' });

          let date = new Date();
          let name =
            'DevolucionCompraTarjeta_' +
            date.getDate().toString().padStart(2, '0') +
            (date.getMonth() + 1).toString().padStart(2, '0') +
            date.getFullYear();

          this.downloadPDF(file, name);
        }
      },
      (error) => console.error(error)
    );
  }

  public downloadPDF(data: any, name: string) {
    let file = new Blob([data], { type: 'application/pdf' });
    FileSaver.saveAs(file, name + '.pdf');
  }
}
